import { SwitchableModeThemeProvider } from '@redis-ui/styles';
import { ThemeSwitchProviderProps } from './ThemesProvider.types';
import { theme as themeLight2 } from '../../themeLight2/theme';
import { theme as themeDark2 } from '../../themeDark2/theme';
import { ThemeChangeHandler } from './ThemeChangeHandler';

const THEME_STORAGE_KEY = 'theme';

const ThemesProvider = ({ children }: ThemeSwitchProviderProps) => {
  return (
    <SwitchableModeThemeProvider
      lightTheme={themeLight2}
      darkTheme={themeDark2}
      storageKey={THEME_STORAGE_KEY}
      defaultThemeMode="system"
      allowSystemThemeMode
    >
      <ThemeChangeHandler />
      {children}
    </SwitchableModeThemeProvider>
  );
};

export default ThemesProvider;
